module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-06-e753d61063335391293ee14f958e753f.jpg";